<template>
  <div class="values py-3">
    <b-container>
      <div class="text-center mb-5">
        <h1 class="font-weight-bold">Our Values</h1>
        <p class="text-muted">
          These core values guide everything we do and every interaction we have
          with our <br />
          customers.
        </p>
      </div>

      <b-row>
        <b-col
          v-for="(item, index) in values"
          :key="index"
          cols="12"
          md="6"
          lg="3"
          class="mb-4 d-flex"
        >
          <div class="value-card text-center p-4 shadow-sm flex-fill">
            <div class="icon-wrapper mb-3" v-html="item.icon"></div>
            <h5 class="font-weight-bold">{{ item.title }}</h5>
            <p class="text-muted">{{ item.description }}</p>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "OurValues",
  data() {
    return {
      values: [
        {
          title: "Family Values",
          description:
            "As a family-owned business, we treat every customer like family with honest, caring service.",
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" stroke="#0d47a1" fill="none" viewBox="0 0 24 24" stroke-width="2"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 6 4 4 6.5 4c1.74 0 3.41 1.01 4.13 2.44h.74C13.09 5.01 14.76 4 16.5 4 19 4 21 6 21 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>`,
        },
        {
          title: "Safety First",
          description:
            "Your safety is our priority. We follow strict safety protocols and use only quality parts.",
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" stroke="#0d47a1" fill="none" viewBox="0 0 24 24" stroke-width="2"><path d="M12 2L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-3z"/></svg>`,
        },
        {
          title: "Excellence",
          description:
            "We're committed to delivering exceptional workmanship and exceeding customer expectations.",
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" stroke="#0d47a1" fill="none" viewBox="0 0 24 24" stroke-width="2"><circle cx="12" cy="8" r="5"/><path d="M8.5 21h7l-3.5-6z"/></svg>`,
        },
        {
          title: "Reliability",
          description:
            "Count on us for prompt, professional service whenever you need garage door assistance.",
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" stroke="#0d47a1" fill="none" viewBox="0 0 24 24" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg>`,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.values {
  background: #fdfdfd;

  .value-card {
    border-radius: 12px;
    background: #fff;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
    }
  }

  .icon-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #e3f2fd; // light blue bg

    svg {
      width: 28px;
      height: 28px;
      fill: #0d47a1; // blue icon
    }
  }

  h5 {
    margin-top: 10px;
    margin-bottom: 8px;
    font-size: 18px;
    color: #000;
  }

  p {
    font-size: 16px;
    line-height: 22px;
  }
}
@media (max-width: 768px) {
  h1 {
    font-size: 30px;
  }
}
</style>
